import { render, staticRenderFns } from "./sysDocumentManage.vue?vue&type=template&id=1226c984&scoped=true"
import script from "./sysDocumentManage.vue?vue&type=script&lang=js"
export * from "./sysDocumentManage.vue?vue&type=script&lang=js"
import style0 from "./sysDocumentManage.vue?vue&type=style&index=0&id=1226c984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1226c984",
  null
  
)

export default component.exports